import { Component, EventEmitter, Input, OnInit, Output, ViewChildren } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { AddgroupComponent } from '../../group/addgroup/addgroup.component';
@Component({
  selector: 'app-addsubgroup',
  templateUrl: './addsubgroup.component.html',
  styleUrls: ['./addsubgroup.component.css']
})
export class AddsubgroupComponent implements OnInit{
  @ViewChildren('inputfirst') firstipcontrol;
  
  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Subgroup";

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  subgroupColl: any = [];
  groupColl: any = [];



  subgroupform = new FormGroup({
    subgroupid: new FormControl(null),
    groupid: new FormControl(null, Validators.required),
    subgroupname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  @Input() subgroupid: number = 0;
  @Input() subgroupname: any = '';
  @Input() groupid: number = null;
  @Output() emitData = new EventEmitter();


  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,private productFindService: NgbModal, 
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.subgroupid = params.id
      }
    });
    this.fnServiceChanges();
  }


  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }

      }
      else {
        this.fnUserFailedForm();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }
    });
  }

  ngOnInit() {
    try{
      if (this.loginService.fnCheckCompany()) {
      if(this.loginService.fnCheckUser()){ 
        if(this.fnCheckUserPririvilage()){       
          this.isloading=true;
          this.fnOnInitForm();
        }
        else{
          this.fnUserFailedForm();
        }
      }
      else{
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }       
    }catch(ex){
      this.fnShowErrorMsg(ex);
    }
}
  ngAfterViewInit() {
    //this.firstipcontrol.first.nativeElement.focus();
  }
  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.subgroupform.reset();
      this.fnInitializeSubgroupFormGroup();

      if (this.subgroupid > 0) {
        this.fngetSubgroup();
      }
      this.fngetGroup();

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.subgroupid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeSubgroupFormGroup() {
    this.subgroupform.setValue({
      subgroupid: 0,
      groupid: this.groupid,
      subgroupname: '',
      inactive: false,

    })
  }



  //Get 
  fngetGroup() {
    var data = {
      'groupid': 0,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getGroup(data)
      .subscribe(
        (res) => {
          this.groupColl = res.json().result;

        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Get 
  fngetSubgroup() {
    var data = {
      'subgroupid': this.subgroupid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getSubgroup(data)
      .subscribe(
        (res) => {
          this.subgroupColl = res.json().result;
          var editdata = this.subgroupColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }

  //Save Btn Click
  fnSaveBtnClick() {
    try {
      if (this.saveloading) {
        return;
      }
       
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.subgroupform.valid) {
        this.saveloading = true;
        //Check
        var data = {
          'subgroupid': this.subgroupid,
          'subgroupname': this.subgroupform.get('subgroupname').value,
          'groupid': this.subgroupform.get('groupid').value,
          'inactive': this.subgroupform.get('inactive').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckSubgroup(data).subscribe(
          (res) => {
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.subgroupform.get('subgroupid').value > 0) {
                //Update Department
                this.fnSetSubgroup(data);
              }
              else {
                //Insert Department
                this.fnInsertSubgroup(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false;
                this.subgroupform.controls['subgroupname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false;
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }
  }



  //Insert
  fnInsertSubgroup(data) {

    this.appService.fnInsertSubgroup(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().status === 200) {

          var result = res.json().result;

          var rtnsubgroupid = 0;
          if (result.length > 0) {
            rtnsubgroupid = result[0].subgroupid
          }


          this.toastr.success('', "The new subgroup has been added successfully.Insert Successfully");
          this.emitData.emit(rtnsubgroupid);
          this.activeModal.close(true);

        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }
  //Set
  fnSetSubgroup(data) {

    this.appService.fnSetSubgroup(data).subscribe(
      (res) => {
        this.saveloading = false;
        if (res.json().result != "") {
          this.toastr.success('', "The Subgroup has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.subgroupid, data.subgroupname);

          this.emitData.emit(this.subgroupid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading = false;
        this.toastr.error('Error', err);
      });

  }
  private fnAddGroup() {

    const modalRef = this.productFindService.open(AddgroupComponent, { size: <any>'m' });
    modalRef.componentInstance.groupColl=this.groupColl
    modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      this.fngetGroup();

      if (receivedEntry > 0) {
        this.subgroupform.patchValue({ groupid: receivedEntry })
      }
    });

  }



  private fnEditMode(deptBO) {

    this.subgroupform.setValue({
      subgroupid: deptBO.subgroupid,
      groupid: deptBO.groupid,
      subgroupname: deptBO.subgroupname,
      inactive: deptBO.inactive,
    });


    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }


  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),
      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

     } catch {

     }
  }
  public decline() {
    this.activeModal.close(false);
  }


  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }

}
